import { useCallback, useRef } from 'react';

export const useCurrentValueGetter = value => {
    const ref = useRef(value);
    ref.current = value;
    return useCallback(() => ref.current, []);
};
